import Vue from 'vue'
import stateConfig from './config'
import api from '@/api'
import VueLocalStorage from 'vue-localstorage'
import moment from 'moment'
import { reject } from 'lodash'
import axios from 'axios'

Vue.use(VueLocalStorage)

export default {
  setLang: function({ commit }, payload) {
    commit(stateConfig.SET_LANG, payload)
  },
  loading: function({ commit, state }) {
    commit(stateConfig.LOADING)
  },
  login: function({ commit, state }, creds) {
    commit(stateConfig.LOGIN) // show spinner
    return new Promise((resolve, reject) => {
      api.authDefault(creds, function(error, response) {
        if (error) {
          commit(stateConfig.LOGIN_FAIL)

          reject(error)
          return
        }
        if (response.responsecode === 400) {
          resolve({
            code: response.responsecode,
            reason: response.reason
          })
        } else if (response.responsecode === 200) {
          state.botlist = response.botlist

          state.userid = creds.userid
          state.isFacebook = false
          state.loginChannel = 'account'
          state.accessToken = response.sessiontoken

          if (state.botlist.length == 0) {
            state.newcomer = true
            Vue.localStorage.set('newcomer', state.newcomer)
          } else {
            state.newcomer = false
            Vue.localStorage.set('newcomer', state.newcomer)
          }

          Vue.localStorage.set('botlist', JSON.stringify(state.botlist))
          Vue.localStorage.set('userid', state.userid)
          Vue.localStorage.set('token', state.accessToken)
          Vue.localStorage.set('FB', state.isFacebook)
          Vue.localStorage.set('loginChannel', state.loginChannel)
          Vue.localStorage.set('groupname', response.groupname)
          Vue.localStorage.set('can_change_payment_status', `${response.can_change_payment_status}`)
          Vue.localStorage.set('can_add_member_project', `${response.can_add_member_project}`)
          Vue.localStorage.set( 'can_add_same_member_project', `${response.can_add_same_member_project}`)

          if (response.admingroupid) {
            state.admingroupid = response.admingroupid
            Vue.localStorage.set('admingroupid', state.admingroupid)
          }
          if (response.adminsubgroupid) {
            state.adminsubgroupid = response.adminsubgroupid
            Vue.localStorage.set('adminsubgroupid', state.adminsubgroupid)
          }
          try {
            if (response.privilege) {
              state.privilege = response.privilege
              Vue.localStorage.set('privilege', JSON.stringify(state.privilege))
            }
          } catch (error) {
            state.privilege = null
          }

          if (response.partner_code) {
            state.partner_code = response.partner_code
            Vue.localStorage.set('partner_code', state.partner_code)
          } else {
            state.partner_code = undefined
            Vue.localStorage.set('partner_code', state.partner_code)
          }

          Vue.localStorage.set('otp_correct', false)
          Vue.localStorage.set('thaiid_login', false)
          Vue.localStorage.set('azure_login', false)

          commit(stateConfig.LOGIN_SUCCESS)
          resolve({
            code: response.responsecode
          })
        } else {
        }
      })
    })
  },
  loginotp: async function({ commit, state }, error) {
    return new Promise((resolve, reject) => {
      try {
        commit(stateConfig.LOGIN_SUCCESS)
        Vue.localStorage.set('otp_correct', true)
        resolve({
          code: 200
        })
      } catch (error) {
        reject(error)
      }
    })
  },
  loginSso: function({ commit, state }, response) {
    commit(stateConfig.LOGIN) // show spinner
    return new Promise((resolve, reject) => {
      state.botlist = JSON.parse(response.botlist)
      state.userid = response.userid
      state.isFacebook = false
      state.loginChannel = 'account'
      state.accessToken = response.sessiontoken

      if (state.botlist.length == 0) {
        state.newcomer = true
        Vue.localStorage.set('newcomer', state.newcomer)
      } else {
        state.newcomer = false
        Vue.localStorage.set('newcomer', state.newcomer)
      }

      Vue.localStorage.set('botlist', JSON.stringify(state.botlist))
      Vue.localStorage.set('userid', state.userid)
      Vue.localStorage.set('token', state.accessToken)
      Vue.localStorage.set('FB', state.isFacebook)
      Vue.localStorage.set('loginChannel', state.loginChannel)

      if (response.admingroupid) {
        state.admingroupid = response.admingroupid
        Vue.localStorage.set('admingroupid', state.admingroupid)
      }
      if (response.adminsubgroupid) {
        state.adminsubgroupid = response.adminsubgroupid
        Vue.localStorage.set('adminsubgroupid', state.adminsubgroupid)
      }
      try {
        if (response.privilege) {
          state.privilege = JSON.parse(response.privilege)
          Vue.localStorage.set('privilege', JSON.stringify(state.privilege))
        }
      } catch (error) {
        state.privilege = null
      }

      if (response.partner_code) {
        state.partner_code = response.partner_code
        Vue.localStorage.set('partner_code', state.partner_code)
      } else {
        state.partner_code = undefined
        Vue.localStorage.set('partner_code', state.partner_code)
      }

      commit(stateConfig.LOGIN_SUCCESS)
      resolve({
        code: response.responsecode
      })
    })
  },
  loginThaID: function({ commit, state }, creds) {
    commit(stateConfig.LOGIN) // show spinner
    return new Promise((resolve, reject) => {
      try {
        api.authThaID(creds, function(error, response) {
          if (error) {
            commit(stateConfig.LOGIN_FAIL)

            reject(error)
            return
          }
          if (response.responsecode === 400) {
            resolve({
              code: response.responsecode,
              reason: response.reason
            })
          } else if (response.responsecode === 200) {
            Vue.localStorage.set('thaiid_login', true)
            state.botlist = response.botlist

            state.userid = creds.adminid
            state.isFacebook = false
            state.loginChannel = 'account'
            state.accessToken = response.sessiontoken

            if (state.botlist.length == 0) {
              state.newcomer = true
              Vue.localStorage.set('newcomer', state.newcomer)
            } else {
              state.newcomer = false
              Vue.localStorage.set('newcomer', state.newcomer)
            }

            Vue.localStorage.set('botlist', JSON.stringify(state.botlist))
            Vue.localStorage.set('userid', state.userid)
            Vue.localStorage.set('token', state.accessToken)
            Vue.localStorage.set('FB', state.isFacebook)
            Vue.localStorage.set('loginChannel', state.loginChannel)
            Vue.localStorage.set('groupname', response.groupname)
            Vue.localStorage.set('can_change_payment_status', `${response.can_change_payment_status}`)

            if (response.admingroupid) {
              state.admingroupid = response.admingroupid
              Vue.localStorage.set('admingroupid', state.admingroupid)
            }
            if (response.adminsubgroupid) {
              state.adminsubgroupid = response.adminsubgroupid
              Vue.localStorage.set('adminsubgroupid', state.adminsubgroupid)
            }
            try {
              if (response.privilege) {
                state.privilege = response.privilege
                Vue.localStorage.set('privilege', JSON.stringify(state.privilege))
              }
            } catch (error) {
              state.privilege = null
            }

            if (response.partner_code) {
              state.partner_code = response.partner_code
              Vue.localStorage.set('partner_code', state.partner_code)
            } else {
              state.partner_code = undefined
              Vue.localStorage.set('partner_code', state.partner_code)
            }


            commit(stateConfig.LOGIN_SUCCESS)
            resolve({
              code: response.responsecode
            })
          } else {
          }
        })
       } catch (error) {
        reject(error)
      }
    })
  },
  loginAzure: function({ commit, state }, creds) {
    commit(stateConfig.LOGIN) // show spinner
    return new Promise((resolve, reject) => {
      try {
        api.authAzure(creds, function(error, response) {
          if (error) {
            commit(stateConfig.LOGIN_FAIL)

            reject(error)
            return
          }
          if (response.responsecode === 400) {
            resolve({
              code: response.responsecode,
              reason: response.reason
            })
          } else if (response.responsecode === 200) {
            Vue.localStorage.set('azure_login', true)
            state.botlist = response.botlist

            state.userid = creds.adminid
            state.isFacebook = false
            state.loginChannel = 'account'
            state.accessToken = response.sessiontoken

            if (state.botlist.length == 0) {
              state.newcomer = true
              Vue.localStorage.set('newcomer', state.newcomer)
            } else {
              state.newcomer = false
              Vue.localStorage.set('newcomer', state.newcomer)
            }

            Vue.localStorage.set('botlist', JSON.stringify(state.botlist))
            Vue.localStorage.set('userid', state.userid)
            Vue.localStorage.set('token', state.accessToken)
            Vue.localStorage.set('FB', state.isFacebook)
            Vue.localStorage.set('loginChannel', state.loginChannel)
            Vue.localStorage.set('groupname', response.groupname)
            Vue.localStorage.set('can_change_payment_status', `${response.can_change_payment_status}`)

            if (response.admingroupid) {
              state.admingroupid = response.admingroupid
              Vue.localStorage.set('admingroupid', state.admingroupid)
            }
            if (response.adminsubgroupid) {
              state.adminsubgroupid = response.adminsubgroupid
              Vue.localStorage.set('adminsubgroupid', state.adminsubgroupid)
            }
            try {
              if (response.privilege) {
                state.privilege = response.privilege
                Vue.localStorage.set('privilege', JSON.stringify(state.privilege))
              }
            } catch (error) {
              state.privilege = null
            }

            if (response.partner_code) {
              state.partner_code = response.partner_code
              Vue.localStorage.set('partner_code', state.partner_code)
            } else {
              state.partner_code = undefined
              Vue.localStorage.set('partner_code', state.partner_code)
            }

            commit(stateConfig.LOGIN_SUCCESS)
            resolve({
              code: response.responsecode
            })
          } else {
          }
        })
       } catch (error) {
        reject(error)
      }
    })
  },
  loginFB: function({ commit, state, dispatch }, creds) {
    commit(stateConfig.LOGIN)
    return new Promise((resolve, reject) => {
      api.getLongLiveToken(creds, function(error, response) {
        if (error) {
          commit(stateConfig.LOGIN_FAIL)
          reject(error)
          return
        }

        api.getPageList({ token: response.longlivetoken }, function(
          errorPageList,
          responsePageList
        ) {
          if (errorPageList) {
            commit(stateConfig.LOGIN_FAIL)
            reject(new Error(error))
          }

          let pagelist = []
          if (responsePageList) {
            pagelist = responsePageList.map(function(page, index) {
              return page.id
            })
          }

          state.userid = creds.userid
          state.pagelist = responsePageList
          state.fbAccessToken = response.longlivetoken
          state.isFacebook = true
          state.loginChannel = creds.channel
          state.fbScope = creds.scope

          Vue.localStorage.set('fbtoken', state.fbAccessToken)
          Vue.localStorage.set('userid', state.userid)
          Vue.localStorage.set('pagelist', JSON.stringify(state.pagelist))
          Vue.localStorage.set('FB', state.isFacebook)
          Vue.localStorage.set('loginChannel', state.loginChannel)
          Vue.localStorage.set('fbScope', state.fbScope)
          let data = {
            userid: creds.userid,
            pageidlist: pagelist,
            access_token: state.fbAccessToken
          }
          dispatch('getBotlist', data).then(
            response => {
              commit(stateConfig.LOGIN_SUCCESS)
              resolve()
            },
            error => {
              commit(stateConfig.LOGIN_FAIL)
              reject(error)
            }
          )
        })
      })
    })
  },
  updateNewBotlist: function({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      let pagelist = []
      if (state.pagelist) {
        state.pagelist.map(function(value, index) {
          pagelist.push(value.id)
        })
      }

      let data = {
        userid: state.userid,
        pageidlist: pagelist,
        access_token: state.fbAccessToken
      }
      dispatch('getBotlist', data).then(
        response => {
          // commit(stateConfig.LOGIN_SUCCESS)
          if (state.selectedBot != null) {
            if (state.botlist) {
              state.botlist.map(function(val) {
                if (val.pageid === state.selectedBot.pageid) {
                  dispatch('selectBot', val)
                  return false
                }
              })
            }
          }
          resolve()
        },
        error => {
          // commit(stateConfig.LOGIN_FAIL)
          reject(error)
        }
      )
    })
  },
  getBotlist: function({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      api.checkBotlist(data, function(error, response) {
        if (error) {
          reject(new Error(error))
        }

        if (response && response.pageidlist) {
          let botlist = response.botlist
          // state.botlist = botlist
          commit('SET_BOTLIST', botlist)
          state.accessToken = response.sessiontoken
          if (state.isFacebook)
            state.facebook_name = response.facebook_name ? response.facebook_name : ''
          else state.facebook_name = state.userid

          if (response.admingroupid) {
            state.admingroupid = response.admingroupid
            Vue.localStorage.set('admingroupid', state.admingroupid)
          }
          if (response.adminsubgroupid) {
            state.adminsubgroupid = response.adminsubgroupid
            Vue.localStorage.set('adminsubgroupid', state.adminsubgroupid)
          }
          try {
            if (response.privilege) {
              state.privilege = JSON.parse(response.privilege)
              Vue.localStorage.set('privilege', JSON.stringify(state.privilege))
            }
          } catch (error) {
            state.privilege = null
          }

          Vue.localStorage.set('facebook_name', state.facebook_name)
          Vue.localStorage.set('botlist', JSON.stringify(state.botlist))
          Vue.localStorage.set('token', state.accessToken)
          if (response.partner_code) {
            state.partner_code = response.partner_code
            Vue.localStorage.set('partner_code', state.partner_code)
          } else {
            state.partner_code = undefined
            Vue.localStorage.set('partner_code', state.partner_code)
          }
        }
        resolve()
      })
    })
  },
  logout: async function({ commit, state }, error) {
    await api.logout()
    return new Promise((resolve, reject) => {
      // Vue.localStorage.remove('token')
      // Vue.localStorage.remove('userid')
      // Vue.localStorage.remove('botlist')
      // Vue.localStorage.remove('selectedBot')
      // Vue.localStorage.remove('fbtoken')
      // // Vue.localStorage.remove('FB')
      // Vue.localStorage.remove('pagelist')
      // Vue.localStorage.remove('partner_code')

      // Vue.localStorage.remove('admingroupid')
      // Vue.localStorage.remove('adminsubgroupid')
      // Vue.localStorage.remove('privilege')
      // Vue.localStorage.remove('otp_correct')
      // Vue.localStorage.remove('thaiid_login')
      localStorage.clear()

      state.admingroupid = null
      state.adminsubgroupid = null
      state.privilege = null

      state.userid = null
      state.botlist = null
      state.selectedBot = null
      state.isSelectedBot = false
      // state.isFacebook = false
      state.accessToken = null
      state.fbAccessToken = null
      state.pagelist = null
      state.partner_code = undefined
      if (error) {
        state.systemError = error
      }
      // eslint-disable-next-line no-undef
      if ($('.modal-backdrop')) {
        // eslint-disable-next-line no-undef
        $('.modal-backdrop').remove()
      }
      commit(stateConfig.LOGOUT)

      resolve()
    })
  },
  selectBot: function({ state, commit, dispatch }, bot) {
    if (state.selectedBot && bot && bot.pageid !== state.selectedBot.pageid) {
      dispatch('updatePaypalTrackingId', null)
    }
    Vue.localStorage.set('selectedBot', JSON.stringify(bot))
    commit(stateConfig.SELECT_NEW_BOT, bot)
    commit(stateConfig.SELECT_BOT)
  },
  unselectBot: function({ state, commit, dispatch }) {
    dispatch('updatePaypalTrackingId', null)
    Vue.localStorage.remove('selectedBot')
    state.selectedBot = null
    state.isSelectedBot = false
  },
  updateBotlist: function({ state, commit }, botlist) {
    state.botlist = botlist
    Vue.localStorage.set('botlist', JSON.stringify(state.botlist))
  },
  updatePagelist: function({ state, commit }) {
    if (!state.isFacebook) {
      return false
    }
    api.getPageList({ token: state.fbAccessToken }, function(error, response) {
      if (error) {
        console.error(error)
        return false
      }

      state.pagelist = response
      Vue.localStorage.set('pagelist', JSON.stringify(state.pagelist))

      return true
    })
  },
  sidebar: function({ commit, state }, value) {
    if (value) {
      commit(stateConfig.SIDEBAR)
    }
    commit(stateConfig.SIDEBAR)
  },
  updatePaypalTrackingId: function({ commit, state }, value) {
    state.paypalTrackingId = value
    if (value == null) {
      Vue.localStorage.remove('paypalTrackingId')
    } else {
      Vue.localStorage.set('paypalTrackingId', state.paypalTrackingId)
    }
  },
  updateMerchantId: function({ commit, state }, value) {
    state.selectedBot.paypal_merchantid = value
    Vue.localStorage.set('selectedBot', JSON.stringify(state.selectedBot))
    commit(stateConfig.SELECT_NEW_BOT, state.selectedBot)
    commit(stateConfig.SELECT_BOT)
  },
  updateSetting: function({ commit, state }, value) {
    commit(stateConfig.UPDATE_SETTING, value)
  },
  updateWelcomeMessage: function({ commit, state }, value) {
    commit(stateConfig.UPDATE_WELCOME_MESSAGE, value)
  },
  updateBotDetail: function({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      let data = { pageid: state.selectedBot.pageid }
      api.getBotDetail(data, function(error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.data) {
          if (response.data.hasOwnProperty('page_access_token')) {
            delete response.data.page_access_token
          }
          state.selectedBot = { ...state.selectedBot, ...response.data }

          Vue.localStorage.set('selectedBot', JSON.stringify(state.selectedBot))
          if (state.botlist) {
            state.botlist.map(function(bot, index) {
              if (bot.pageid === state.selectedBot.pageid) {
                state.botlist[index] = state.selectedBot
                Vue.localStorage.set('botlist', JSON.stringify(state.botlist))
                return false
              }
            })
          }
          commit(stateConfig.SELECT_BOT)
        }

        resolve(response)
      })
    })
  },
  addModalWelcome: function({ commit, state }) {
    commit(stateConfig.UPDATE_MODAL_WELCOME, true)
  },
  clearModalWelcome: function({ commit, state }) {
    commit(stateConfig.UPDATE_MODAL_WELCOME, false)
  },
  clearAlert: function({ state, commit }, name) {
    var pageid = null
    if (state.selectedBot) {
      pageid = state.selectedBot.pageid
    }
    commit(stateConfig.UPDATE_ALERT, { name: name, show: false, pageid: pageid })
  },
  getProducts: function({ state }) {
    return new Promise((resolve, reject) => {
      let data = {
        pageid: state.selectedBot.pageid
      }
      if (
        state.selectedBot.useketshop == true &&
        state.selectedBot.ketshop_api_key &&
        state.selectedBot.ketshop_api_secret
      ) {
        data['ketshop_api_key'] = state.selectedBot.ketshop_api_key
        data['ketshop_api_secret'] = state.selectedBot.ketshop_api_secret
      }

      api.getProducts(data, function(error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.productlist) {
          resolve(response.productlist)
        } else {
          reject()
        }
      })
    })
  },
  loadProducts: function({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.ecommerce.loadingProduct = true
      dispatch('getProducts').then(
        products => {
          state.ecommerce.products = products
          state.ecommerce.loadingProduct = false

          resolve()
        },
        error => {
          console.error(error)
          state.ecommerce.loadingProduct = false
          reject(error)
        }
      )
    })
  },
  getCategories: function({ state }) {
    return new Promise((resolve, reject) => {
      var data = {
        pageid: state.selectedBot.pageid
      }
      if (
        state.selectedBot.useketshop == true &&
        state.selectedBot.ketshop_api_key &&
        state.selectedBot.ketshop_api_secret
      ) {
        data['ketshop_api_key'] = state.selectedBot.ketshop_api_key
        data['ketshop_api_secret'] = state.selectedBot.ketshop_api_secret
      }
      api.getCategories(data, function(error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.categorylist) {
          resolve(response.categorylist)
        } else {
          reject()
        }
      })
    })
  },
  loadCategory: function({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.ecommerce.loadingCategory = true
      dispatch('getCategories').then(
        categories => {
          state.ecommerce.categories = categories
          state.ecommerce.loadingCategory = false
          resolve()
        },
        error => {
          console.error(error)
          state.ecommerce.loadingCategory = false
          reject(error)
        }
      )
    })
  },
  getUserStatus: function({ state }) {
    return new Promise((resolve, reject) => {
      let data = {
        pageid: state.selectedBot.pageid
      }

      api.getUserStatus(data, function(error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.data) {
          resolve(response.data)
        } else {
          reject()
        }
      })
    })
  },
  loadStatus: function({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.loadingUserStatus = true
      dispatch('getUserStatus').then(
        status => {
          state.userStatus = []
          if (status.length > 0) {
            status.map(val => {
              state.userStatus.push(val.status)
            })
          }
          state.loadingUserStatus = false
          resolve()
        },
        error => {
          console.error(error)
          state.loadingUserStatus = false
          reject(error)
        }
      )
    })
  },
  getSetting: function({ state }) {
    return new Promise((resolve, reject) => {
      api.getSetting({ pageid: state.selectedBot.pageid }, function(error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.data) {
          resolve(response.data)
        } else {
          reject()
        }
      })
    })
  },
  loadSetting: function({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.loadingSetting = true
      dispatch('getSetting').then(
        setting => {
          var contents = []
          setting.map(function(content, index) {
            contents[content.contenttype] = content
          })
          state.setting = contents
          state.loadingSetting = false
          resolve()
        },
        error => {
          console.error(error)
          state.loadingSetting = false
          reject(error)
        }
      )
    })
  },
  getCharges: function({ state }) {
    return new Promise((resolve, reject) => {
      api.getAllShipingCharge({ pageid: state.selectedBot.pageid }, function(error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.shippinglist) {
          resolve(response.shippinglist)
        } else {
          reject()
        }
      })
    })
  },
  loadCharges: function({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.ecommerce.loadingCharges = true
      dispatch('getCharges').then(
        charges => {
          state.ecommerce.charges = charges
          state.ecommerce.loadingCharges = false
          resolve()
        },
        error => {
          console.error(error)
          state.ecommerce.loadingCharges = false
          reject(error)
        }
      )
    })
  },
  getLinePushMessageCount: function({ state }, value) {
    return new Promise((resolve, reject) => {
      var data = { pageid: state.selectedBot.pageid }
      if (value && (value.datefrom || value.dateto)) {
        data.datefrom = moment(value.datefrom).format('YYYY-MM-DD')
        data.dateto = moment(value.dateto).format('YYYY-MM-DD')
      }

      api.getLinePushMessageCount(data, function(error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.data) {
          resolve(response.data)
        } else {
          reject()
        }
      })
    })
  },
  updateLivechatUsers: function({ commit }, payload) {
    commit(stateConfig.SET_LIVECHAT_USERS, payload)
  },
  updateLivechatUser: function({ commit }, payload) {
    commit(stateConfig.SET_LIVECHAT_USER, payload)
  },
  loadLinePushMessageCount: function({ state, dispatch }, value) {
    return new Promise((resolve, reject) => {
      state.loadingLinePushMessageCount = true
      dispatch('getLinePushMessageCount', value).then(
        linePushMessageCount => {
          state.linePushMessageCount = linePushMessageCount
          state.loadingLinePushMessageCount = false
          resolve()
        },
        error => {
          console.error(error)
          state.loadingLinePushMessageCount = false
          reject(error)
        }
      )
    })
  },
  updateKetshopToken: function({ commit }, payload) {
    commit(stateConfig.SET_KETSHOP_TOKEN, payload)
  },
  async forceLoadLastestUsers({ state, dispatch }) {
    for (const key in state.livechat.userlist) {
      // debugger
      if (state.livechat.userlist.hasOwnProperty(key)) {
        state.livechat.userlist[key].offset = 0
        state.livechat.userlist[key].limit = state.livechat.limitFatchUser
        state.livechat.userlist[key].loading = false
        state.livechat.userlist[key].hasMore = true

        await dispatch('loadLivechatUsers', {
          // type: key
          type: 'all'
        })
      }
    }
  },
  async loadLatestUsers({ state, dispatch }, payload) {
    if (state.livechat.userlist[payload.type]) {
      // console.log("loadLatestUsers")
      var user_config = state.livechat.userlist[payload.type]

      if (user_config.loading || !user_config.isAutoRefresh) {
        return false
      }

      state.livechat.userlist[payload.type].offset = 0
      state.livechat.userlist[payload.type].limit = state.livechat.limitFatchUser

      await dispatch('loadLivechatUsers', payload)
    }
  },
  loadLivechatUsers({ state, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      if (state.livechat.userlist[payload.type]) {
        state.livechat.userlist[payload.type].loading = true
        dispatch('getLivechatUsers', payload).then(
          users => {
            dispatch('updateLivechatUsers', { users: users, type: payload.type })
            // if user less than limit or equal to zero. Livechat will not be fatch new user after 5 sec
            if (
              state.livechat.userlist[payload.type].users.length <
                state.livechat.userlist[payload.type].limit ||
              state.livechat.userlist[payload.type].users.length == 0
            ) {
              state.livechat.userlist[payload.type].hasMore = false
              setInterval(() => {
                state.livechat.userlist[payload.type].hasMore = true
              }, 5000)
            }
            state.livechat.userlist[payload.type].loading = false
            resolve()
          },
          error => {
            state.livechat.userlist[payload.type].loading = false
            reject(error)
          }
        )
      }
    })
  },
  getLivechatUsers: function({ state, getters }, payload) {
    return new Promise((resolve, reject) => {
      var filter = {}
      if (state.filter.search) {
        filter.search = state.filter.search.toLowerCase()
      }
      if (state.filter.assignadminid) {
        filter.assignadminid = state.filter.assignadminid
      }
      if (state.filter.assigngroupid) {
        filter.assigngroupid = state.filter.assigngroupid
      }
      if (state.filter.assignsubgroupid) {
        filter.assignsubgroupid = state.filter.assignsubgroupid
      }

      var data = {
        params: {},
        body: {
          pageid: state.livechat.pageid,
          offset: state.livechat.userlist[payload.type].offset,
          limit: state.livechat.userlist[payload.type].limit,
          inbox: payload.type,
          // app: state.livechat.app,
          app: 'line',
          status: state.livechat.status,
          tags: state.livechat.tags.join(','),
          ...filter
        }
      }
      if (getters.isLivechatSearching) {
        data.body = {
          ...data.body,
          ...state.livechat.filter,
          tags: state.livechat.filter.tags.join(','),
          inbox: 'all'
        }
      } else {
        // data.body.app = state.livechat.app
        data.body.app = 'line'
        data.body.inbox = payload.type
      }
      if (state.livechat.filter.search) {
        Object.assign(data.body, { search: state.livechat.filter.search })
      }

      api.getLiveChatUsers(data, function(error, response) {
        if (error) {
          reject(error)
        }
        if (response && response.data) {
          resolve(response.data)
        } else {
          resolve([])
        }
      })
    })
  },
  updateNewcomer: function({ state }, payload) {
    state.newcomer = payload
    Vue.localStorage.set('newcomer', state.newcomer)
  },
  getPageProfile: function({ state }) {
    return new Promise((resolve, reject) => {
      let data = {
        pageid: state.selectedBot.pageid
      }
      api.getShopProfile(data, function(error, response) {
        if (error) {
          console.error(error)

          reject()
        }

        if (response.shopprofile) {
          resolve(response.shopprofile)
        } else {
          resolve(null)
        }
      })
    })
  },
  loadPageProfile: function({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.loadingPageProfile = true
      dispatch('getPageProfile').then(
        profile => {
          state.pageProfile = profile
          state.loadingPageProfile = false
          resolve()
        },
        error => {
          console.error(error)
          state.loadingPageProfile = false
          reject(error)
        }
      )
    })
  },
  getPartnerProfile: function({ state }) {
    return new Promise((resolve, reject) => {
      api.getPartnerProfile({ partner_code: state.partner_code }, function(error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.data && response.data.length > 0) {
          resolve(response.data[0])
        } else {
          reject()
        }
      })
    })
  },
  loadPartnerProfile: function({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.loadingPartnerProfile = true
      dispatch('getPartnerProfile').then(
        partnerProfile => {
          state.partnerProfile = partnerProfile
          state.loadingPartnerProfile = false
          resolve()
        },
        error => {
          console.error(error)
          state.loadingPartnerProfile = false
          reject(error)
        }
      )
    })
  },
  getAgents: function({ state }) {
    return new Promise(async (resolve, reject) => {
      let data = {
        pageid: state.selectedBot.pageid
      }

      api.getAdmins(data, (error, response) => {
        if (error) {
          console.error(error)
          reject(error)
        }
        resolve(response.data)
      })
    })
  },
  loadAgents: function({ state, dispatch }) {
    return new Promise(async (resolve, reject) => {
      state.loadingAgents = true
      try {
        var agents = await dispatch('getAgents')
        state.agents = agents
        resolve()
      } catch (error) {
        reject(error)
      }
      state.loadingAgents = false
    })
  },
  getAdminGroup: function({ state }) {
    return new Promise(async (resolve, reject) => {
      let data = {
        pageid: state.selectedBot.pageid
      }

      api.getAdminGroup(data, (error, response) => {
        if (error) {
          console.error(error)
          reject(error)
        }
        resolve(response.data)
      })
    })
  },
  loadAgentGroups: function({ state, dispatch }) {
    return new Promise(async (resolve, reject) => {
      state.loadingAgentGroups = true
      try {
        var agents = await dispatch('getAdminGroup')
        state.agentGroups = agents ? agents : []
        resolve()
      } catch (error) {
        reject(error)
      }
      state.loadingAgentGroups = false
    })
  },
  getAdminSubGroup: function({ state }) {
    return new Promise(async (resolve, reject) => {
      let data = {
        pageid: state.selectedBot.pageid
      }

      api.getAdminSubGroup(data, (error, response) => {
        if (error) {
          console.error(error)
          reject(error)
        }
        resolve(response.data)
      })
    })
  },
  loadAgentSubGroups: function({ state, dispatch }) {
    return new Promise(async (resolve, reject) => {
      state.loadingAgentSubgroups = true
      try {
        var agents = await dispatch('getAdminSubGroup')
        state.agentSubgroups = agents ? agents : []
        resolve()
      } catch (error) {
        reject(error)
      }
      state.loadingAgentSubgroups = false
    })
  },
  depamemberinfo({ state, dispatch }, payload) {
    return new Promise(async (resolve, reject) => {
      var data = {
        pageid: state.selectedBot.pageid,
        ...payload
      }
      let res = await api.editDepaMember(data)
      if (res != 200) {
        await Vue.swal.fire({ text: res.reason })
        reject()
      } else {
        resolve(200)
      }
    })
  },
  toggleBotStatus({ state, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      var bot = payload

      api.toggleBotStatus(bot, function(error, response) {
        if (error) {
          reject(error)
        }

        let newbotlist = state.botlist
        var botIndex = newbotlist.findIndex(oldbot => {
          return bot.pageid == oldbot.pageid
        })
        if (newbotlist) {
          newbotlist[botIndex].status = bot.status
          dispatch('selectBot', bot)
          dispatch('updateBotlist', newbotlist)
        }

        resolve()
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js